import * as fromTasks from "../actions/task.actions";
import { GematikTaskTotals } from "../../models/gematik-task-totals.model";

export const FEATURE_KEY = "taskTotals";

export interface TaskTotalsState {
  totals: GematikTaskTotals;
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export const initialState: TaskTotalsState = {
  totals: {
    open: {
      my: 0,
      group: 0,
    },
    due: {
      my: 0,
      group: 0,
    },
    completed: {
      my: 0,
      group: 0,
    },
  },
  loading: false,
  loaded: false,
  error: false,
};

export function reducer(state = initialState, action: fromTasks.TaskActions): TaskTotalsState {
  switch (action.type) {
    case fromTasks.LOAD_TASK_TOTALS: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case fromTasks.LOAD_TASK_TOTALS_SUCCESS: {
      const totals = action.payload;
      return {
        ...state,
        loading: false,
        loaded: true,
        totals,
      };
    }
    case fromTasks.LOAD_TASK_TOTALS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case fromTasks.ADJUST_TASK_TOTALS: {
      const { openMy, openGroup, completedMy, completedGroup } = action.payload;
      return {
        ...state,
        totals: {
          ...state.totals,
          open: {
            my: state.totals.open.my + openMy,
            group: state.totals.open.group + openGroup,
          },
          completed: {
            my: state.totals.completed.my + completedMy,
            group: state.totals.completed.group + completedGroup,
          },
        },
      };
    }
  }
  return state;
}

export const getTaskTotals = (state: TaskTotalsState) => state.totals;
export const getTaskTotalsLoading = (state: TaskTotalsState) => state.loading;
export const getTaskTotalsLoaded = (state: TaskTotalsState) => state.loaded;
